module.exports = __webpack_public_path__ + "static/media/14-mobile.84fa4209.jpg";